import { render } from "./AmenityDetailsEL.vue?vue&type=template&id=55440699&scoped=true"
import script from "./AmenityDetailsEL.vue?vue&type=script&lang=js"
export * from "./AmenityDetailsEL.vue?vue&type=script&lang=js"

import "./AmenityDetailsEL.vue?vue&type=style&index=0&id=55440699&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55440699"]])

export default __exports__